import React, { useEffect } from 'react'
import { Col, Row, Image } from 'react-bootstrap'
import { Breadcrumb } from 'react-breadcrumbs'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { authorization } from 'Module/Auth/Auth'
import { Breadcrumbs } from 'Components/Breadcrumbs'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { SectionLabel } from 'Components/Section/SectionLabel'
import { SectionTitle } from 'Components/Section/SectionTitle'
import { SectionWrapper } from 'Components/Section/SectionWrapper'
import { ButtonEditInsideSection } from 'Components/Buttons/ButtonEditInsideSection'
import { UserDetailsWrapper } from 'Components/UserManagement/UserDetailsWrapper'
import { getUserById } from 'Reducers/Users/actions'
import UserManagementIcon from 'Assets/Images/icons/userManagement'
import { PATHS } from 'Config/Routing/paths'

const ProfilePageBreadcrumbs = () => {
  return (
    <div>
      <Breadcrumbs icon={<UserManagementIcon style={{ width: 24 }} />} />
      <Breadcrumb
        data={{
          title: 'Profile',
          pathname: `${PATHS.main.dashboard}${PATHS.dashboard.profile}`,
        }}
      />
      <Breadcrumb
        data={{
          title: 'Details',
          pathname: `${PATHS.main.dashboard}${PATHS.dashboard.settings}${
            PATHS.dashboard.userManagement
          }`,
        }}
      />
    </div>
  )
}
const ProfilePage = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const userById = useSelector(state => state.users.userById)
  const id = authorization.getUser().id
  useEffect(() => {
    dispatch(getUserById(id))
  }, [])

  return (
    <LayoutDashboard>
      {ProfilePageBreadcrumbs()}
      <UserDetailsWrapper>
        <SectionWrapper className="section-wrapper first">
          <SectionTitle className="section-title">Profile Details</SectionTitle>
          <ButtonEditInsideSection
            onClickHandler={() =>
              history.push(PATHS.main.dashboard + PATHS.profile.edit)
            }
          />
          <Col xs={12}>
            <Col xs={10}>
              <Row>
                <Col xs={3}>
                  <SectionLabel className="section-label">
                    First Name
                  </SectionLabel>
                  {userById.firstName}
                </Col>
                <Col xs={9}>
                  <SectionLabel className="section-label">
                    Last Name
                  </SectionLabel>
                  {userById.lastName}
                </Col>
              </Row>
              <Row>
                <Col xs={3}>
                  <SectionLabel className="section-label">
                    Email Address
                  </SectionLabel>
                  {userById.email}
                </Col>
                <Col xs={3}>
                  <SectionLabel className="section-label">Role</SectionLabel>
                  {userById.role}
                </Col>
              </Row>
            </Col>
            <Col xs={2}>
              <Image
                src={`${userById.profilePicture}?${userById.updatedAt}`}
                className="profile-picture"
              />
            </Col>
          </Col>
        </SectionWrapper>
      </UserDetailsWrapper>
    </LayoutDashboard>
  )
}

export { ProfilePage }



// WEBPACK FOOTER //
// ./src/Containers/Profile/index.js